"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _form = _interopRequireDefault(require("./form"));
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#PolicyImplementationAsset',
    assetType: 'PolicyImplementation'
  },
  owner: {
    gusTeam: 'TBD'
  },
  name: 'Policy Implementation',
  pluralName: 'Policy Implementations',
  publication: {
    uiForm: _form.default,
    inferredBy: [{
      classifiers: ['metadata', 'binary'],
      typeProperty: 'policy-implementation'
    }],
    files: [{
      id: 'metadata',
      classifier: 'metadata',
      packaging: 'yaml'
    }, {
      id: 'mule-binary',
      classifier: 'binary',
      packaging: 'jar'
    }, {
      id: 'peregrine-binary',
      classifier: 'binary',
      packaging: 'wasm'
    }, {
      id: 'bundle',
      classifier: 'policy-bundle',
      packaging: 'zip'
    }],
    minimumInputSets: [{
      files: ['metadata', 'mule-binary']
    }, {
      files: ['metadata', 'peregrine-binary']
    }],
    ootbSteps: [{
      name: 'angModelExtraction'
    }],
    dependenciesRestrictions: {
      minimum: 1,
      maximum: 1,
      permissionLevel: 'contributor',
      allowedTypes: ['policy']
    },
    extensionPoints: [{
      name: 'validation'
    }]
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map